export default __webpack_public_path__ + "static/media/mostaza.251c4388.png";